import { Router } from '@angular/router';
import { CurrentUser } from '../auth/current-user';
import * as i0 from "@angular/core";
import * as i1 from "../auth/current-user";
import * as i2 from "@angular/router";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(currentUser, router) {
        this.currentUser = currentUser;
        this.router = router;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        return this.handle(state.url);
    };
    AuthGuard.prototype.canActivateChild = function (route, state) {
        return this.handle(state.url);
    };
    AuthGuard.prototype.canLoad = function (route) {
        return this.handle(route.path);
    };
    AuthGuard.prototype.handle = function (url) {
        if (this.currentUser.isLoggedIn()) {
            return true;
        }
        this.currentUser.redirectUri = url;
        this.router.navigate(['/login']);
        return false;
    };
    AuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.inject(i1.CurrentUser), i0.inject(i2.Router)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
